import React from 'react';
import { Award, Heart, Clock, Stethoscope } from 'lucide-react';

const Provider = () => {
  const highlights = [
    {
      icon: Clock,
      label: '30+ Years',
      description: 'Clinical Experience'
    },
    {
      icon: Stethoscope,
      label: 'Emergency Medicine',
      description: '7 Years Rural ER'
    },
    {
      icon: Heart,
      label: 'Family Medicine',
      description: 'Long-term Patient Care'
    },
    {
      icon: Award,
      label: 'OU Graduate',
      description: 'Class of 1990'
    }
  ];

  return (
    <section id="provider" className="section-padding bg-[#f8f7f2]">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Provider Photo */}
          <div className="relative">
            <div className="aspect-[4/3] bg-[#e8e7e2] overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_premium-medicine/artifacts/518ga17q_picture%202%20for%20website.jpg"
                alt="Robert C. DiCintio, PA-C with patient"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Experience badge */}
            <div className="absolute -bottom-6 -right-6 bg-[#1a1a1a] text-[#fffef8] p-6 hidden lg:block">
              <p className="font-serif text-3xl text-[#c9a962] mb-1">30+</p>
              <p className="text-sm text-[#b8b8b8]">Years of Excellence</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="gold-accent mb-6"></div>
            <p className="text-[#c9a962] text-sm tracking-wider uppercase mb-3">Meet Your Provider</p>
            <h2 className="font-serif text-3xl md:text-4xl text-[#2d2d2d] mb-2">
              Robert C. DiCintio, PA-C
            </h2>
            <p className="text-[#8a8a8a] text-lg mb-6">Physician Associate</p>
            
            <div className="space-y-4 text-[#5a5a5a] leading-relaxed">
              <p>
                Robert C. DiCintio, PA-C is a dedicated medical provider with more than 
                3 decades of clinical experience. He graduated from the University of 
                Oklahoma College of Family Medicine in 1990, earning his degree as a 
                Physician Associate.
              </p>
              <p>
                He began his career practicing emergency medicine in a rural emergency 
                department, where he spent the first 7 years of his professional life 
                caring for patients in high-acuity and fast-paced settings. Following 
                his work in emergency medicine, PA DiCintio transitioned into family 
                medicine, where he has practiced ever since.
              </p>
              <p>
                This background allows him to combine acute care expertise with long-term, 
                relationship-based care for patients of all ages.
              </p>
              <p>
                PA DiCintio is passionate about preventative medicine. He firmly believes 
                that <span className="italic text-[#c9a962]">"prevention is better than cure"</span> and 
                is committed to helping patients stay healthy through proactive care, 
                early intervention, and individualized treatment plans.
              </p>
              <p>
                He takes pride in listening closely to his patients, truly getting to 
                know them, and going above and beyond to support their long-term health 
                and well-being.
              </p>
            </div>

            {/* Highlights */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10 pt-10 border-t border-[#e8e7e2]">
              {highlights.map((item, index) => (
                <div key={index} className="text-center">
                  <div className="w-12 h-12 bg-[#fffef8] flex items-center justify-center mx-auto mb-3">
                    <item.icon size={20} className="text-[#c9a962]" />
                  </div>
                  <p className="font-medium text-[#2d2d2d] text-sm">{item.label}</p>
                  <p className="text-xs text-[#8a8a8a]">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Provider;
